var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoSearchData(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.6364 30C58.6364 45.8154 45.8154 58.6364 30 58.6364C14.1846 58.6364 1.36364 45.8154 1.36364 30C1.36364 14.1846 14.1846 1.36364 30 1.36364C45.8154 1.36364 58.6364 14.1846 58.6364 30Z",
    stroke: "#CCCCCC",
    strokeWidth: 2.72727
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.2498 40.1168L35.1828 34.0177C38.1957 30.3825 37.8197 25.0213 34.329 21.8421C30.8383 18.6629 25.4654 18.7883 22.1268 22.1269C18.7882 25.4655 18.6628 30.8384 21.842 34.3291C25.0212 37.8198 30.3824 38.1958 34.0177 35.1829L40.1168 41.2499L41.2498 40.1168ZM21.1604 28.3926C21.1604 24.3984 24.3983 21.1604 28.3925 21.1604C32.3867 21.1604 35.6246 24.3984 35.6246 28.3926C35.6246 32.3868 32.3867 35.6247 28.3925 35.6247C24.3983 35.6247 21.1604 32.3868 21.1604 28.3926Z",
    fill: "#0A0A0A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSearchData);
export default __webpack_public_path__ + "static/media/no-search-data.172de61ef877dbb538b413e4a3f393b6.svg";
export { ForwardRef as ReactComponent };